module.exports = __webpack_public_path__ + "img/347.eae08d4e.jpg";